import { ConditionalPartial } from '../../../../utils';

import { CreateShippingProcessConfigRequestDto } from './create-shipping-process-config.request.dto';

/**
 * DTO for updating shipping process configuration
 * All fields are optional for partial updates
 */
export class UpdateShippingProcessConfigRequestDto extends ConditionalPartial(CreateShippingProcessConfigRequestDto) {}
